import { render, staticRenderFns } from "./ClinicsModuleComponent.vue?vue&type=template&id=0ec4e9fb&scoped=true"
import script from "./ClinicsModuleComponent.vue?vue&type=script&lang=js"
export * from "./ClinicsModuleComponent.vue?vue&type=script&lang=js"
import style0 from "./ClinicsModuleComponent.vue?vue&type=style&index=0&id=0ec4e9fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec4e9fb",
  null
  
)

export default component.exports